// extracted by mini-css-extract-plugin
export default {"table":"CardContent_table__1sbsy"};